import { toast } from 'react-toastify';

import {
  generateCSV as generateCSVService,
  generateEnhancedCSV as generateEnhancedCSVService,
} from '@features/invoices/services/csvService';
import {
  generateChargesCSV as generateChargesCSVService,
  generateChargesEnhancedCSV as generateChargesEnhancedCSVService,
} from '@features/invoices/services/csvServiceCharges';
import { isChargeBasedInvoiceType } from '@features/invoices/services/invoiceType';

export default function useCsvGeneration() {
  const generateCSV = (invoice: any) => {
    try {
      if (isChargeBasedInvoiceType(invoice?.invoice_type)) {
        generateChargesCSVService(invoice);
      } else {
        generateCSVService(invoice);
      }
      toast.info('Generated CSV!', { autoClose: 2000, toastId: 'generate-csv' });
    } catch (err) {
      toast.error('Failed to generate CSV!', { toastId: 'generate-csv-error' });
      console.error('Failed to generate CSV:', err);
    }
  };

  const generateEnhancedCSV = async (invoice: any) => {
    try {
      if (isChargeBasedInvoiceType(invoice?.invoice_type)) {
        // Reads the invoice's charges and moves first, a moment on a large invoice.
        toast.info('Generating Enhanced CSV...', { autoClose: 2000, toastId: 'generate-enhanced-csv-loading' });
        await generateChargesEnhancedCSVService(invoice);
      } else {
        generateEnhancedCSVService(invoice);
      }
      toast.info('Generated Enhanced CSV!', { autoClose: 2000, toastId: 'generate-csv' });
    } catch (err) {
      toast.error('Failed to generate Enhanced CSV!', { toastId: 'generate-csv-error' });
      console.error('Failed to generate Enhanced CSV:', err);
    }
  };

  return {
    generateCSV,
    generateEnhancedCSV,
  };
}
